
var lastLink = document.querySelector('.nav-desktop__tier-1-item:last-of-type')

// console.log(lastLink)

// console.log(lastLink.children[0])
// console.log(lastLink.children[0].href)

var lastLinkHREF = lastLink.children[0].href

if (lastLinkHREF.search('shop-gb') != -1){
  // console.log('yoooo')
  // console.log(lastLinkHREF.search('offer'))

  // Remove Juice Button
  var twoWeekJuiceButtonDiv = document.querySelector('.two-week-juice-button-div')
  twoWeekJuiceButtonDiv.classList.add('no-display')

  // Add Powder Image
  var twoWeekUKImage = document.querySelector('.two-week-challenge-img-uk')
  twoWeekUKImage.classList.remove('no-display')

  // Remove Juice image
  var twoWeekUKImage = document.querySelector('.two-week-challenge-img-usa')
  twoWeekUKImage.classList.add('no-display')

  // Fix Margin on Powder Button
  // var powderButtonUSA = document.querySelector('.two-week-powder-button-usa')
  // powderButton.classList.add('auto-margin')

  // Add Powder UK Button
  var powderButtonUK = document.querySelector('.two-week-powder-button-uk')
  powderButtonUK.classList.remove('no-display')

  // Remove Powder USA Button
  var powderButtonUSA = document.querySelector('.two-week-powder-button-usa')
  powderButtonUSA.classList.add('no-display')
  
} else{
  // console.log('no yoooo')
}
